<template>
  <div>
    register
  </div>
</template>

<script setup>

</script>

<style scoped src="./index.css"></style>
